export default __webpack_public_path__ + "static/media/tt.40727c62.svg";